import FormTranslationContext from "context/FormTranslationContext";
import getObjectValue from "libs/getObjectValue";
import { useContext } from "react";
import NoticeGlossaryInput from "../../components/inputs/NoticeGlossaryInput";
import Tr from "translations/Translations";
import Typography from "components/Typography";
import NoticeTextInput from "../../components/inputs/NoticeTextInput";
import { Collapse } from "@material-ui/core";
function PurchaserData(
    {
        id,
        formikProps
    }) {
    const gId = (name) => id + "." + name;
    const gVal = (name, prefix = true, defaultVal = null) => getObjectValue(prefix ? gId(name) : name, formikProps.values, defaultVal);
    const updateNotice = getObjectValue('_updateNotice', formikProps.values, true);
    const { getDict } = useContext(FormTranslationContext)

    return (
        <>
            <Typography>{Tr("bzp_notice_purchaser_data_info")}</Typography>
            <br />

            <NoticeTextInput
                formikProps={formikProps}
                id={gId("phoneNumber")}
            />

            <NoticeTextInput
                formikProps={formikProps}
                id={gId("faxNumber")}
            />
            <NoticeTextInput
                formikProps={formikProps}
                id={gId("email")}
                required
            />

            <NoticeGlossaryInput
                id={gId("type")}
                formikProps={formikProps}
                items={getDict("SL.MO.013")}
                required
                disabled={updateNotice}
            />

            <Collapse in={gVal("type") === "1.5"}>
                <NoticeTextInput
                    formikProps={formikProps}
                    id={gId("typeOther")}
                    required
                />
            </Collapse>

        </>
    )
}

PurchaserData.propTypes = {};
export default PurchaserData;